import Layout from "../../components/Layout/Layout";
import LevelSelectCard from "../../components/LevelSelectCard/LevelSelectCard";
import levelSelectData from "../../data/levelSelectData";
import "./LevelSelect.scss";

const LevelSelect = ({ gameName }) => {
  const levels = levelSelectData.map((level) => {
    return {
      ...level,
      linkTo: `/${gameName?.toLowerCase()}-game/play/${level.level}`,
    };
  });

  return (
    <Layout requiresAuth={true}>
      <div className="level-select">
        <h1 className="level-select__heading">{gameName} Game Levels</h1>
        <div className="level-select__container">
          {levels.map((level) => (
            <LevelSelectCard
              key={level.heading}
              heading={level.heading}
              isLocked={level.isLocked}
              headingImg={level.headingImg}
              paragraph={level.paragraph}
              buttonLabel={level.buttonLabel}
              linkTo={level.linkTo}
            />
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default LevelSelect;
